import React from "react";
import Layout from "layouts";
import CouponsComponent from "./CouponsComponent";

export default function Coupons() {
  return (
    <Layout breadCrumb={[{ label: "Voucher Codes", to: "#" }]}>
      <CouponsComponent />
    </Layout>
  );
}
